import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch, useSelector } from "react-redux";
import { editCurrencyinfo, getCurrency } from "actions/currency.action";
import EditCurrency from "./Editcurrency.jsx";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";

const Currencylist = () => {
  const dispatch = useDispatch();
  const { currencyList } = useSelector((state) => state.currency);

  const [openForm, setOpenForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState(null);

  React.useEffect(() => {
    dispatch(getCurrency());
  }, [dispatch]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    try {
      const data = {
        currencyCode: event.currencyCode,
        name: event.name,
        symbol: event.symbol,
        active: event.active,
      };
      await dispatch(editCurrencyinfo(event.currencyCode, data));
      dispatch(getCurrency());
      setOpenForm(false);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );
  return (
    <div className="settings-grid">
      <Grid data={currencyList?.data}>
        <Column field="symbol" title=" " cell={SignatureCell} width="80" />
        <Column field="currencyCode" title="Code" width="100" />
        <Column field="name" title="Name" />
        <Column cell={ActiveCell} title="Active" field="active" width="75" />
        <Column title=" " cell={MyEditCommandCell} width="60" />
      </Grid>
      {openForm && (
        <EditCurrency
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default Currencylist;
